export const MILE = 'mi';
export const YARD = 'yd';
export const FEET = 'ft';
export const INCH = 'in';
export const KILOMETER = 'km';
export const METER = 'm';
export const CENTIMETER = 'cm';
export const MILLIMETER = 'mm';
export const NAUTICAL_MILE = 'nmi';
